// Module overview: NotFound component and its UI interaction logic.
import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
// Component: renders not found UI and related interactions.
const NotFound = () => {
  const navigate = useNavigate(); // React Router hook to navigate between pages
  const { t } = useTranslation(); // Hook for multilingual translations
  return (
    <>
      <Container className="pageContainer">
        <div className="contentWrapper">
          <img 
          src="/images/404-error.png" 
          alt="404 Error Illustration" 
          className="illustration"
          loading="lazy" 
          decoding="async" 
           />
           <h1 className="mainTitle">{t("NotFound.title")}</h1>
          <Button onClick={() => navigate("/")} variant="primary" className="goBackButton">
            {t("NotFound.backBtn")}
          </Button>
        </div>
      </Container>    
    </>
  );
};

export default NotFound;
